import { errorNotifier, successNotifier } from "../../../components/NotificationHandler";
import http, { AUTH_ROUTES } from "../../../services/api";

export const fetchStreetsData = async (setStreetsData, setLoadingStreets) => {
  try {
    setLoadingStreets(true);
    const { data } = await http.get("/user/house");
    
    if (!data?.result?.data?.houses || !Array.isArray(data.result.data.houses)) {
      console.error("Invalid data structure received:", data);
      throw new Error("Invalid data structure received from API");
    }

    // Transform the data into a format that allows mapping by street
    const transformedData = data.result.data.houses.reduce((acc, house) => {
      // Validate house data
      if (!house?.streetId?._id || !house?.streetId?.streetName || !house?.houseNumber || !house?._id) {
        console.warn("Skipping invalid house data:", house);
        return acc;
      }

      const { streetId, houseNumber, _id: houseId } = house;
      const { _id: streetIdValue, streetName, streetDescription } = streetId;

      // Ensure each street has an entry with its name and corresponding house details
      if (!acc[streetIdValue]) {
        acc[streetIdValue] = {
          streetName,
          streetId: streetIdValue,
          streetDescription,
          houses: [],
          houseDetails: {} // Add a map of house numbers to IDs
        };
      }

      // Add house number if not already present
      if (!acc[streetIdValue].houses.includes(houseNumber)) {
        acc[streetIdValue].houses.push(houseNumber);
        // Store house ID mapped to house number
        acc[streetIdValue].houseDetails[houseNumber] = houseId;
      }

      return acc;
    }, {});

    // Sort house numbers for each street
    Object.values(transformedData).forEach(street => {
      street.houses.sort((a, b) => {
        // Try to sort numerically first
        const numA = parseInt(a);
        const numB = parseInt(b);
        if (!isNaN(numA) && !isNaN(numB)) {
          return numA - numB;
        }
        // Fall back to string sorting
        return String(a).localeCompare(String(b));
      });
    });

    console.log("Transformed street data:", transformedData);
    setStreetsData(transformedData);
    setLoadingStreets(false);
  } catch (error) {
    console.error("Error in fetchStreetsData:", error);
    setLoadingStreets(false);
    errorNotifier(error.response?.data?.result?.message || "Failed to load streets data");
  }
};



export const signupTenant = async (payload, setLoading) => {
  try {
    setLoading(true);
    const { data } = await http.post(AUTH_ROUTES.SIGNUP, payload);

    if (data.result.success) {
        successNotifier(data.result?.message);
        return true; 
    } else {
      errorNotifier("Signup failed. Please try again.");
      return false; 
    }
  } catch (e) {
    if (e?.response?.data?.errors) {
        const errorMessages = e.response.data.errors
          .map((error) => error.msg)
          .join(", ");
        errorNotifier(errorMessages || "Signup failed with errors.");
      } else {
        errorNotifier("Please check your network connection!!!");
      }
  } finally {
    setLoading(false);
  }
};
